<template>
  <AuthLayout :mode="mode">
    <Section heading="Mail Details" :mode="mode" />
    <AppCard :mode="mode">
      <template #body>
        <div
          class="divide-y overflow-hidden rounded-xl border"
          :class="[
            mode === 'dark'
              ? 'divide-dark-border border-dark-border bg-dark-sidebar'
              : 'divide-border-10 border-border-10 bg-white-100',
          ]"
        >
          <div
            class="divide-y"
            :class="[
              mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
            ]"
          >
            <div
              class="flex items-start divide-x sm:flex-col sm:gap-3 sm:divide-x-0 sm:p-4"
              :class="[
                mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
              ]"
            >
              <div class="w-[140px] sm:w-full">
                <div class="px-4 py-5 sm:p-0">
                  <span class="text-[14px] font-semibold sm:text-[18px]"
                    >From</span
                  >
                </div>
              </div>
              <div class="flex-1 sm:w-full">
                <div
                  class="flex items-center gap-2.5 px-4 py-5 sm:grid sm:items-start sm:gap-3 sm:p-0"
                >
                  <span class="text-[14px] font-medium sm:leading-none"
                    >Team Sales TeleTraders</span
                  >
                  <span
                    class="border-x px-2.5 text-[14px] font-medium underline sm:border-0 sm:px-0 sm:leading-none"
                    :class="[
                      mode === 'dark'
                        ? 'border-dark-border'
                        : 'border-black-10',
                    ]"
                    >teamsales@teletraders.net</span
                  >
                  <span class="text-[14px] font-medium sm:mt-1 sm:leading-none"
                    >TeleTraders, LLC</span
                  >
                </div>
              </div>
            </div>
            <div
              class="flex items-start divide-x sm:flex-col sm:gap-3 sm:divide-x-0 sm:p-4"
              :class="[
                mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
              ]"
            >
              <div class="w-[140px] sm:w-full">
                <div class="px-4 py-5 sm:p-0">
                  <span class="text-[14px] font-semibold sm:text-[18px]"
                    >Date</span
                  >
                </div>
              </div>
              <div class="flex-1">
                <div class="flex items-center gap-1 px-4 py-5 sm:p-0">
                  <span class="text-[14px] font-semibold">1/23/2025</span>
                  <span
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-dark-60',
                    ]"
                    >12:26:28 PM</span
                  >
                </div>
              </div>
            </div>
            <div
              class="flex items-start divide-x sm:flex-col sm:gap-3 sm:divide-x-0 sm:p-4"
              :class="[
                mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
              ]"
            >
              <div class="w-[140px] sm:w-full">
                <div class="px-4 py-5 sm:p-0">
                  <span class="text-[14px] font-semibold sm:text-[18px]"
                    >Subject</span
                  >
                </div>
              </div>
              <div class="flex-1">
                <div class="px-4 py-5 sm:p-0">
                  <span class="text-[14px] font-medium"
                    >eTN Sell: NETWORK PRODUCTS: 168 Cisco Catalyst C1000 9120AX
                    Switches and more Used</span
                  >
                </div>
              </div>
            </div>
            <div
              class="flex items-start divide-x sm:flex-col sm:gap-3 sm:divide-x-0 sm:p-4"
              :class="[
                mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
              ]"
            >
              <div class="w-[140px] sm:w-full">
                <div class="px-4 py-5 sm:p-0">
                  <span class="text-[14px] font-semibold sm:text-[18px]"
                    >Body</span
                  >
                </div>
              </div>
              <div class="flex-1">
                <div class="px-4 py-5 sm:p-0">
                  <div
                    class="space-y-4 divide-y"
                    :class="[
                      mode === 'dark'
                        ? 'divide-dark-border'
                        : 'divide-border-10',
                    ]"
                  >
                    <div class="grid gap-2">
                      <span class="text-[14px] font-semibold"
                        >eTN Broadcast</span
                      >
                      <span class="text-[14px] font-semibold"
                        >Manufacturer:
                        <span
                          class="font-medium"
                          :class="[
                            mode === 'dark'
                              ? 'text-dark-text'
                              : 'text-black-60',
                          ]"
                          >NETWORK PRODUCTS</span
                        ></span
                      >
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >We are currently offering to sell the following items
                        on behalf of one of our end-user customers.</span
                      >
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >Should you have an interest, we invite you to submit
                        your best offer.</span
                      >
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >Feel free to reach out if you have any inquiries or
                        require further information.</span
                      >
                      <ul
                        class="grid list-disc gap-1 pl-4 text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                      >
                        <li>91 Cisco Catalyst 9120AX Series Used</li>
                        <li>
                          77 Cisco Catalyst C1000-8T-2G-L Ethernet Switch Used
                        </li>
                        <li>74 Cisco Rack Mount Kit - Used</li>
                        <li>
                          42 Cisco Digital Network Architecture Advantage - Term
                          License Used
                        </li>
                        <li>34 Cisco Aironet Dual-Band Dipole Antenna Used</li>
                        <li>
                          30 Cisco Catalyst 9300 48-port UPOE, Network Advantage
                          Used
                        </li>
                        <li>20 Cisco 4 x 1G/10G Network Module Used</li>
                        <li>15 Cisco C9200 Stack Kit Spare Used</li>
                        <li>
                          13 Cisco Digital Network Architecture Advantage for
                          Catalyst 93 Used
                        </li>
                        <li>
                          13 Cisco Catalyst 9300 24-port UPOE, Network Advantage
                          Used
                        </li>
                        <li>
                          12 Cisco Catalyst C9300-48UXM-A Ethernet Switch Used
                        </li>
                        <li>
                          10 1100W AC 80+ PLATINUM CONFIG 1 P/S SPARE Used
                        </li>
                      </ul>
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >Thank you,</span
                      >
                    </div>
                    <div class="grid gap-2 pt-4">
                      <span class="text-[14px] font-semibold">Bonnie</span>
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >SS031825</span
                      >
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >Contact:
                        <span
                          :class="[
                            mode === 'dark'
                              ? 'text-white-100'
                              : 'text-black-100',
                          ]"
                          >Team Sales TeleTraders</span
                        ></span
                      >
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >ITAD Association status:
                        <span
                          :class="[
                            mode === 'dark'
                              ? 'text-white-100'
                              : 'text-black-100',
                          ]"
                          >NON-MEMBER</span
                        ></span
                      >
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >Company:
                        <span
                          :class="[
                            mode === 'dark'
                              ? 'text-white-100'
                              : 'text-black-100',
                          ]"
                          >TeleTraders, LLC</span
                        ></span
                      >
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >Contact email:
                        <span
                          :class="[
                            mode === 'dark'
                              ? 'text-white-100'
                              : 'text-black-100',
                          ]"
                          >teamsales@teletraders.net</span
                        ></span
                      >
                      <span
                        class="text-[14px] font-medium"
                        :class="[
                          mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                        ]"
                        >If you wish to not receive Broadcast Instant E-mail for
                        listings for this Manufacturer or you wish to just
                        receive a summary every day, please log on to
                        www.ascdi.com and click on your name to change your
                        profile.</span
                      >
                    </div>
                    <div class="grid gap-3 pt-4">
                      <span class="text-[14px] font-semibold">Materials</span>
                      <div class="flex items-center justify-between">
                        <div class="flex items-center gap-1.5">
                          <FileImage :size="20" :stroke-width="1.75" />
                          <span
                            class="mt-[2px] text-[14px] font-medium leading-none"
                            >ASCDI</span
                          >
                        </div>
                        <button
                          class="flex items-center gap-1.5 text-[14px] font-semibold text-primary-100"
                        >
                          <span class="mt-[3px]">Downloads</span>
                          <Download :size="18" :stroke-width="1.75" />
                        </button>
                      </div>
                      <div class="flex items-center justify-between">
                        <div class="flex items-center gap-1.5">
                          <FileImage :size="20" :stroke-width="2" />
                          <span
                            class="mt-[2px] text-[14px] font-medium leading-none"
                            >ASCDI</span
                          >
                        </div>
                        <button
                          class="flex items-center gap-1.5 text-[14px] font-semibold text-primary-100"
                        >
                          <span class="mt-[3px]">Downloads</span>
                          <Download :size="18" :stroke-width="2" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </AppCard>
  </AuthLayout>
</template>

<script>
import { Download, FileImage } from "lucide-vue-next";
import Section from "@C/Common/Section.vue";
import AuthLayout from "@A/AuthLayout.vue";
import AppCard from "@C/Common/AppCard.vue";
import { useUserStore } from "@S/user";
import { useToastStore } from "@S/toast";
import { useLoaderStore } from "@S/loader";
import ApiRequest from "@L/ApiRequest";
import { useGlobalErrorHandler } from "@L/errorHandler";

export default {
  name: "MailDetails",
  components: {
    AuthLayout,
    Section,
    FileImage,
    Download,
    AppCard,
  },
  props: {
    mode: String,
  },
  data() {
    return {
      id: "",
      listing: {},
    };
  },
  setup() {
    const userStore = useUserStore();
    const toastStore = useToastStore();
    const loaderStore = useLoaderStore();
    const { handleError } = useGlobalErrorHandler();
    return {
      userStore,
      toastStore,
      loaderStore,
      handleError,
    };
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getListing();
  },
  methods: {
    async getListing() {
      this.loaderStore.setIsLoading(true);
      try {
        const { data } = await ApiRequest().get(`/listing/${this.id}`);
        if (data) {
          this.listing = data;
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
  },
};
</script>
